import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const settingsOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.SETTINGS,
    steps: [
        {
            id: "set-welcome",
            title: "Central de Configurações",
            description:
                "Aqui ficam todas as configurações da sua plataforma. Cada card leva a um módulo específico.",
            position: "center",
        },
        {
            id: "set-general",
            title: "Configurações Gerais",
            description:
                "Defina parâmetros globais da aplicação como nome da empresa, perfil, dados de nota fiscal, moeda e idioma.",
            targetId: "settings-card-general",
            position: "bottom",
        },
        {
            id: "set-categories",
            title: "Categorias e Tarifas",
            description:
                "Crie categorias de serviço (Econômico, Conforto, Premium) e defina tarifas por quilômetro, tempo e taxa base.",
            targetId: "settings-card-categories",
            position: "bottom",
        },
        {
            id: "set-vehicle-types",
            title: "Tipos de Veículo",
            description:
                "Mapeie os tipos de veículos disponíveis por categoria e defina ícones e requisitos mínimos.",
            targetId: "settings-card-vehicle-types",
            position: "bottom",
        },
        {
            id: "set-payment",
            title: "Métodos de Pagamento",
            description:
                "Configure quais métodos de pagamento estão disponíveis: dinheiro, cartão, PIX ou Mercado Pago.",
            targetId: "settings-card-payment",
            position: "bottom",
        },
        {
            id: "set-mercadopago",
            title: "Mercado Pago",
            description:
                "Vincule sua conta Mercado Pago via OAuth e configure o split de comissão da plataforma.",
            targetId: "settings-card-mercadopago",
            position: "bottom",
        },
    ],
};
